import { setItem } from 'owa-local-storage';
import type { ProjectId } from '../schema';
import getProjectsInLocalStorage from './getProjectsInLocalStorage';
import ProjectInLocalStorage, { OUTLOOK_SPACES_LOCAL_STORAGE_KEY } from './ProjectInLocalStorage';

export default function setProjectInLocalStorage(
    projectId: ProjectId,
    settings: Partial<ProjectInLocalStorage> | null
) {
    const projectsInLocalStorage = getProjectsInLocalStorage();

    if (settings === null) {
        delete projectsInLocalStorage[projectId];
    } else {
        projectsInLocalStorage[projectId] = {
            ...projectsInLocalStorage[projectId],
            ...settings,
        };
    }

    setItem(window, OUTLOOK_SPACES_LOCAL_STORAGE_KEY, JSON.stringify(projectsInLocalStorage));
}
